import OrderDetails from "./details/OrderDetails";

const ManageOrder = ({ details }) => {
  return <OrderDetails details={details?.data} />;
};

export default ManageOrder;
